import { render, staticRenderFns } from "./InterGrpHelplist.vue?vue&type=template&id=19aa5540&"
import script from "./InterGrpHelplist.vue?vue&type=script&lang=js&"
export * from "./InterGrpHelplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports